export default "__VITE_ASSET__BzCqMzrg__"